export default function SideModal({ children, isOpen, setIsOpen, title, subtitle, widthClass = 'w-[70%]' }) {
  return (
    <div className="relative">

      {/* Overlay */}
      <div
        className={`z-60 fixed inset-0 transition-opacity ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setIsOpen(false)}
      ></div>

      {/* Side Modal */}
      <div
        className={`z-60 fixed top-0 right-0 ${widthClass} h-full bg-white shadow-2xl !shadow-gray-500 rounded-s-2xl p-6 border border-gray-200 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="fixed top-3 right-5">
          <button
            className="text-lg text-gray-800 hover:text-gray-900"
            onClick={() => setIsOpen(false)}
          >
            <i class="fa-regular fa-xmark"></i>
          </button>
        </div>

        {/* Heading */}
        <div>
          <p className="text-sm font-inter font-semibold text-[#6B7280]">
            {title}
          </p>
          <p
            className="text-xl font-inter font-semibold text-[#1E293B]"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          ></p>
        </div>
        <div className="h-full overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
}
